import React, { useState, useEffect, useMemo } from "react";

const GROUP_META = {
  morning: { label: "\u05D1\u05D5\u05E7\u05E8", color: "#f59e0b", bg: "#fffbeb" },
  midday:  { label: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD", color: "#0ea5e9", bg: "#f0f9ff" },
  evening: { label: "\u05E2\u05E8\u05D1", color: "#6366f1", bg: "#eef2ff" },
};

const Columns = ({ zmanimList = [], title, showTitle = true, hebrewDate, countdown }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dayName = now.toLocaleDateString("he-IL", { weekday: "long" });
  const dateLabel = hebrewDate?.hebrewShort ? `${dayName} ${hebrewDate.hebrewShort}` : dayName;
  const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  const groups = useMemo(() => {
    const result = { morning: [], midday: [], evening: [] };
    zmanimList.forEach(item => {
      const g = result[item.group];
      if (g) g.push(item);
    });
    return result;
  }, [zmanimList]);

  const visibleGroups = useMemo(() =>
    ["morning", "midday", "evening"].filter(gk => groups[gk].length > 0),
  [groups]);

  return (
    <div style={{
      direction: "rtl", width: "100%", height: "100%",
      backgroundColor: "#fff", overflow: "hidden",
      display: "flex", flexDirection: "column",
      fontFamily: "inherit",
    }}>
      {showTitle && (
        <div style={{
          backgroundColor: "#1e3a5f",
          padding: "0.8rem 1.5rem",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          flexShrink: 0, flexWrap: "wrap", gap: "4px",
        }}>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: "1.2em" }}>{title}</span>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ color: "#94a3b8", fontSize: "0.85em" }}>{dateLabel}</span>
            {countdown && (
              <div style={{ display: "flex", alignItems: "center", gap: "5px", backgroundColor: "rgba(255,255,255,0.12)", padding: "3px 10px", borderRadius: "12px" }}>
                <span style={{ color: "#94a3b8", fontSize: "0.75em" }}>{countdown.label}</span>
                <span style={{ color: "#fbbf24", fontSize: "0.9em", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{countdown.remaining}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{
        flex: 1, overflow: "auto",
        display: "grid", gridTemplateColumns: `repeat(${visibleGroups.length}, 1fr)`, gap: "0",
      }}>
        {visibleGroups.map((gk, gi) => {
          const gm = GROUP_META[gk];
          const items = groups[gk];
          return (
            <div key={gk} style={{
              display: "flex", flexDirection: "column",
              borderLeft: gi < visibleGroups.length - 1 ? "1px solid #e2e8f0" : "none",
            }}>
              <div style={{
                backgroundColor: gm.bg,
                borderBottom: `3px solid ${gm.color}`,
                padding: "0.6rem 0.8rem",
                textAlign: "center", flexShrink: 0,
              }}>
                <span style={{ color: gm.color, fontWeight: 700, fontSize: "0.95em" }}>{gm.label}</span>
              </div>
              <div style={{ flex: 1, padding: "0.3rem 0" }}>
                {items.map((item, i) => {
                  const toMinAdj = t => { const [h, m] = t.split(":").map(Number); return (h === 0 ? 24 : h) * 60 + m; };
          const isPast = toMinAdj(item.time) < toMinAdj(hhmm);
                  const isCurrent = item.time === hhmm;
                  return (
                    <div key={item.key} style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "0.45rem 0.6rem",
                      opacity: isPast ? 0.65 : 1,
                      backgroundColor: isCurrent ? `${gm.color}10` : "transparent",
                      borderRight: isCurrent ? `3px solid ${gm.color}` : "3px solid transparent",
                      borderBottom: i < items.length - 1 ? "1px solid #e2e8f040" : "none",
                    }}>
                      <span style={{
                        color: isCurrent ? gm.color : "#1e293b",
                        fontSize: "0.85em", fontWeight: isCurrent ? 700 : 500,
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                        flex: 1, minWidth: 0,
                      }}>{item.label}</span>
                      <span style={{
                        color: isCurrent ? gm.color : "#64748b",
                        fontSize: "0.9em", fontWeight: 700,
                        fontVariantNumeric: "tabular-nums", flexShrink: 0, marginRight: "6px",
                      }}>{item.time}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Columns;
